module.exports = __webpack_public_path__ + "media/images/footer/fdva-d60af96841a74f8f50a561dd91f0d6b5.jpg";